"use client";

import type { FC, Ref } from "react";
import { BasicCard, type ChildrenProp, type IconProps } from "@huub-web/ui";

export type AnalysisListProps = ChildrenProp & {
  title?: string;
  icon?: IconProps["icon"];
  categoryID?: string;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * @deprecated
 */
export const AnalysisList: FC<AnalysisListProps> = ({
  title,
  icon,
  children,
  ref,
  ...props
}) => (
  <BasicCard
    ref={ref}
    title={title}
    icon={icon}
    indicatorVariant="infoSurface"
    elevated
    {...props}
  >
    {children}
  </BasicCard>
);
